export default __webpack_public_path__ + "e8c34e191836af34c9159348121da426.svg";